import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../state/actions';
import LazyLoadPicture from '../lazyLoadPicture/LazyLoadPicture';
import TitoloBlocco from '../titoloBlocco/TitoloBlocco';
import CustomButton from '../customButton/CustomButton';
import { URLASSOLUTO } from '../../../utils/urlassoluto';

const MagazineItem = ({
	name,
	sottotitolo,
	ImmagineElencoMagazine,
	routeName,
	linkSeo,
}) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const paginestaticheTranslation = useSelector(
		(state) => state.translations.paginestatiche
	);

	useEffect(() => {
		console.log(ImmagineElencoMagazine);
	}, []);

	const onMagazineClick = (event) => {
		event.preventDefault();

		// mostro spinner
		dispatch(allActions.isFetchingAction.loadSpinner());

		dispatch(
			allActions.changePageActions.changePage('', routeName, linkSeo, history)
		);
	};

	return (
		<div className='col-span-60 sm:col-span-20 px-3 m-5 sm:mx-3 2xl:mx-6 magazineHomeItem spanServerSide'>
			<a href={URLASSOLUTO + linkSeo} onClick={onMagazineClick}>
				<LazyLoadPicture
					imgName={`323x156-${ImmagineElencoMagazine.file_name}`}
					imgPath={`${ImmagineElencoMagazine.folder}/thumbs`}
					imgWidth='323'
					imgHeight='156'
					imgStyle='flex-start mb-6 minContent w-full'
					imgAlt={name}
				/>
			</a>
			<TitoloBlocco
				titoloStyle='titolo font-opensanssemibold text-ribola-dove-gray text-lg flex mb-2 line-clamp-2'
				titolo={name.toUpperCase()}
			/>
			<TitoloBlocco
				titoloStyle='titolo text-ribola-dove-gray text-sm flex mb-6 line-clamp-2'
				titolo={sottotitolo}
			/>
			<CustomButton
				buttonRouteName={routeName}
				buttonLink={linkSeo}
				buttonName={paginestaticheTranslation.scopridipiu.itemName.toUpperCase()}
				buttonStyle='buttonCongressBlue'
			/>
		</div>
	);
};

export default MagazineItem;
